/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbShipping_item = {
    readonly hasShipmentQuotes: boolean | null;
    readonly hasPreQuotedShipping: boolean | null;
    readonly vertical: VerticalType | null;
    readonly itemIsOnHold: boolean | null;
    readonly address: {
        readonly itemAddress: string | null;
        readonly isGalleryRoomAddress: boolean | null;
    } | null;
    readonly attributes: {
        readonly leadTime: ReadonlyArray<{
            readonly option: {
                readonly urlLabel: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly shipmentQuotes: ReadonlyArray<{
        readonly totalAmount: {
            readonly amount: number | null;
        } | null;
        readonly serviceMethod: {
            readonly region: {
                readonly regionName: string | null;
            } | null;
        } | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_item">;
    readonly " $refType": "PdpSharedBlurbShipping_item";
};
export type PdpSharedBlurbShipping_item$data = PdpSharedBlurbShipping_item;
export type PdpSharedBlurbShipping_item$key = {
    readonly " $data"?: PdpSharedBlurbShipping_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbShipping_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbShipping_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasShipmentQuotes",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasPreQuotedShipping",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vertical",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": "itemIsOnHold",
      "name": "isOnHold",
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "address",
      "storageKey": null,
      "args": null,
      "concreteType": "Address",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "itemAddress",
          "name": "displayCityStateCountry",
          "args": [
            {
              "kind": "Literal",
              "name": "fullCountryName",
              "value": true
            }
          ],
          "storageKey": "displayCityStateCountry(fullCountryName:true)"
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isGalleryRoomAddress",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "attributes",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "leadTime",
          "storageKey": null,
          "args": null,
          "concreteType": "AttributeValue",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "option",
              "storageKey": null,
              "args": null,
              "concreteType": "AttributeOption",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "urlLabel",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "shipmentQuotes",
      "storageKey": null,
      "args": null,
      "concreteType": "ShipmentQuote",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "totalAmount",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "amount",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "serviceMethod",
          "storageKey": null,
          "args": null,
          "concreteType": "ShipmentServiceMethod",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "region",
              "storageKey": null,
              "args": null,
              "concreteType": "Region",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "regionName",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_item",
      "args": null
    }
  ]
};
(node as any).hash = '690fc0952c7df85b7990890a983136dc';
export default node;
